import { Injectable } from '@angular/core';
import { MPSBaseService } from './base/mps-base.service'; 
import { Observable } from 'rxjs';
import { MpsJobManagementOptions, MpsJobManagementResult, MpsJobManagementType } from '../../models/mps.models';

@Injectable({
    providedIn: 'root',
})
/** Il servizio MPSService implementa le logiche client ed espone tutti i metodi del MPSBaseService
 * che mappa il controller REST Workflow 1:1.
 * */ 
export class MPSService extends MPSBaseService {
    constructor() {
        super();
    }

    copyJobs(jobIDs: number[]): Observable<MpsJobManagementResult[]> {
        const mpsJobManagementOptions: MpsJobManagementOptions = {
            jobIds: jobIDs,
            failureReason: null,
            managementType: MpsJobManagementType.Copy  // 0
        };

        return this.modifyJob(mpsJobManagementOptions);
    }

    deleteJobs(jobIDs: number[]): Observable<MpsJobManagementResult[]> {
        const mpsJobManagementOptions: MpsJobManagementOptions = {
            jobIds: jobIDs,
            failureReason: 17,
            managementType: MpsJobManagementType.Delete  // 1
        };

        return this.modifyJob(mpsJobManagementOptions);
    }

    unblockJobs(jobIDs: number[]): Observable<MpsJobManagementResult[]> {
        const mpsJobManagementOptions: MpsJobManagementOptions = {
            jobIds: jobIDs,
            failureReason: null,
            managementType: MpsJobManagementType.Unblock  // 2
        };

        return this.modifyJob(mpsJobManagementOptions);
    }
}

